import React from 'react';
import { Row, Col, DropdownButton, MenuItem } from 'react-bootstrap';
import Geosuggest from 'react-geosuggest';
import { withTranslation } from 'react-i18next';
import { humanize } from 'underscore.string';
import { sluggify } from 'utils/localization/utils';
import CreateAddressForm from './CreateAddressForm';
import GoogleParser from './google-address-parser';
const ADDRESS_TYPE = 'Address';
class CreateLocation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.state.type = ADDRESS_TYPE;
    }
    handleSuggest(address) {
        var location = GoogleParser.parse(address);
        location.custom = true;
        this.setState({ location });
    }
    render() {
        const { t } = this.props;
        return (React.createElement("div", null,
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12 },
                    React.createElement("strong", { style: { paddingRight: 10 } }, t('LOCATION_TYPE')),
                    React.createElement(DropdownButton, { id: 1, title: t(sluggify(humanize(this.state.type))) || t('SELECT_TYPE'), onSelect: (eventKey) => this.setState({ type: eventKey }), bsSize: "small" },
                        React.createElement(MenuItem, { eventKey: ADDRESS_TYPE }, t(sluggify(ADDRESS_TYPE)))),
                    React.createElement(Row, { style: { marginTop: 10 } },
                        React.createElement(Col, { xs: 12 }, t('PROVIDE_NEARBY_ADDRESS_MSG'))),
                    this.state.type && (React.createElement(Row, { style: { marginTop: 10 } },
                        React.createElement(Col, { xs: 12 },
                            React.createElement(Geosuggest, { placeholder: t('LOCATION_SEARCH'), style: { input: { className: 'form-control' } }, onSuggestSelect: (address) => this.handleSuggest(address) })))),
                    this.state.type === 'Address' && this.state.location && (React.createElement(CreateAddressForm, { location: this.state.location, onLocationDrag: (lat, lng) => this.handleLocationDrag(lat, lng), onCreateLocationCancel: this.props.onCreateLocationCancel, onCreateLocation: this.props.onCreate, error: this.props.error, locationPending: this.props.locationPending }))))));
    }
}
export default withTranslation()(CreateLocation);
